import React from 'react';
import { useSelector } from 'react-redux';
import { selectPaymentCheckFailed } from '../../../../store/slices/payment/paymentSelectors';
import { Grid, Row, Col } from 'rsuite';
import Notice from '../../../user-feedback/Notice';
import { SelectConfigSupportEmail } from '../../../../store/slices/config/configSelectors';

const PaymentCheckFailed = () => {
  const paymentCheckFailed = useSelector(selectPaymentCheckFailed);
  const supportEmail = useSelector(SelectConfigSupportEmail);

  return (
    paymentCheckFailed && (
      <Grid fluid>
        <Row>
          <Col xs={24}>
            <Notice
              message={`Something went wrong while verifying your payment. 
                            Do not try and make this payment again. Please contact`}
              actionComponent={
                <a href={`mailto:${supportEmail}`}>{supportEmail}.</a>
              }
            />
          </Col>
        </Row>
      </Grid>
    )
  );
};

export default PaymentCheckFailed;
